export enum operation {
  create = 'create',
  edit = 'edit',
}
